(function () {
	function swiperInit() {
		if(document.querySelector(".js-media-sublist")) {
			subSliderInit(true);
		}
		sliderInit(true);
		updatethumbnail(true);
	}

	document.addEventListener("shopify:section:load", function () {
		swiperInit();
	});

	document.addEventListener("resize", function () {
		swiperInit();
	});

	document.addEventListener("visibilitychange", function () {
		swiperInit();
	});

	swiperInit();
})();
